<template>
  <div :class="addPadding ? 'page-container add-padding' : 'page-container'">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PageContainer',
  props: ['addPadding'],
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .page-container
    max-width: 1500px
    margin: 0 auto

    &.add-padding
      padding: 0 3rem

</style>
